import { GlobalFooter } from '@/patterns/global-footer/src/global-footer';
import StickyContainer from '@/patterns/sticky-container/sticky-container';
import { FeatureExposed } from '@/utils/feature-exposed/use-feature-exposed';
import { ParentScrollTracking } from '@/utils/scroll-tracking/parent-scroll-tracker';

import { ReturningUserBanner } from '../components/returning-user-banner.tsx';

import { JiraSitesProvider } from './jira-sites-provider/jira-sites-provider.tsx';
import { LoggedInHeroSection } from './logged-in-hero';
import SoftwareJiraLoggedInNavbar from './logged-in-nav/software-jira-logged-in-navbar.tsx';

export const OrganicLoggedInJiraProductTourOverview = () => {
	return (
		<FeatureExposed
			experimentKey="jfind-1506-after-d7-gubtp-organic"
			group="jfind-1506-after-d7-gubtp-organic"
		>
			<FeatureExposed
				experimentKey="jfind-organic-jpt-logged-in-redesign"
				group="jfind-organic-jpt-logged-in-redesign"
			>
				<JiraSitesProvider>
					<StickyContainer>
						<SoftwareJiraLoggedInNavbar />
					</StickyContainer>
					<ParentScrollTracking scrollTrackingEnabled={true} pageId="jsw">
						<ReturningUserBanner />
						<LoggedInHeroSection />
						<GlobalFooter />
					</ParentScrollTracking>
				</JiraSitesProvider>
			</FeatureExposed>
		</FeatureExposed>
	);
};
